export default "__VITE_ASSET__1daa2072__"